import { connect } from 'react-redux';
import QuotaTransferRevision from './QuotaTransferRevision';
function mapStateToProps(state) {
  return {
    requestSend:
      state.requestState['requestTransfer-RevisionSend'] ||
      state.requestState['requestQuotaTransferSend'],
    canRevokeQuotaTransfer:
      state.authentication.currentUser.canRevokeQuotaTransfer
  };
}

function mapDispatchToProps() {
  return {};
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QuotaTransferRevision);
